import React from 'react'
import { useHistory } from 'react-router-dom'
import { Table } from '../../../admin/components/Table/Table'
import { formatPrice } from '../../../utils/functions'

const PurchasesList = ({ purchases }) => {
    const history = useHistory()
    return (
        <div>
            <Table>
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Id Orden</th>
                        <th>Estado</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {purchases.map(purchase => (
                        <tr key={purchase._id} onClick={(e) => {
                            //if (purchase.status ===3) {
                                history.push(`/MarketPlace/Purchases/${purchase._id}`)
                            //}

                        }
                        }>
                            <td>{new Date(purchase.creationDate).toLocaleDateString()}</td>
                            <td>{purchase.code}</td>
                            <td>
                                {purchase.status ===0 && 'Pendiente'}
                                {purchase.status ===1 && 'Rechazado'}
                                {purchase.status ===2 && 'Pagado'}
                                {purchase.status ===3 && 'Despachado'}
                                {purchase.status ===4 && 'Entregado'}
                            </td>
                            <td>{formatPrice(purchase.totalPrice)}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    )
}

export default PurchasesList